import { render, staticRenderFns } from "./InsertLink.vue?vue&type=template&id=16225b9e"
import script from "./InsertLink.vue?vue&type=script&lang=js"
export * from "./InsertLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports